module.exports = __webpack_public_path__ + "static/image/history/pc/201911.jpg?f27e9f57";